<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Beneficios" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <ClubBeneficios v-if="visibleClubBeneficios" class="tarjeta" />
        <Cesur v-if="visibleCesur" class="tarjeta" />
        <TraeUnAmigo v-if="visibleTraeUnAmigo" class="tarjeta" />
        <TallerCRMBeneficios v-if="visibleTallerCRM" class="tarjeta" />
        <TalleresCalidadPremiumBeneficios v-if="visibleTalleresCalidadPremium" class="tarjeta" />
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    visibleTraeUnAmigo() {
      return this.$store.state.portfolio.nsg("lstCodigosAmigo.length") > 0;
    },
    visibleClubBeneficios() {
      return this.$store.state.portfolio.tienePolizasVigorMMT;
    },
    visibleTallerCRM() {
      const tienePolizaAutos =
        this.$store.state.portfolio.tienePolizaAutos == "S";
      const esPuroMMT = this.$store.state.portfolio.cliente.purezaPuroMMT;
      const esMadrid =
        this.$store.state.portfolio.cliente.codPostal && this.$store.state.portfolio.cliente.codPostal.startsWith("28");
      return tienePolizaAutos && esPuroMMT && esMadrid;
    },
    visibleTalleresCalidadPremium() {
      const esPuroMMT = this.$store.state.portfolio.cliente.purezaPuroMMT;
      const tienePolizaAutos =
        this.$store.state.portfolio.tienePolizaAutos == "S";
      return esPuroMMT && tienePolizaAutos;
    },
    visibleCesur() {
      return this.$store.state.portfolio.cliente.purezaPuroMMT;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
